module.exports = __webpack_public_path__ + "static/img/banner-2026.62d1b3e9.png";